import clsx from 'clsx';

import { twMerge } from '@polyai/ui/utils/twMerge';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  selected?: boolean;
  children: React.ReactNode;
}

export const Wrapper = ({ selected, children, className, ...props }: Props) => {
  const klass = twMerge(
    clsx(
      `w-[var(--step-node-width)] relative`,
      'p-sm1 bg-background rounded-medium',
      'border border-solid border-border-subtle',
      className,
      // Show selected state when any handle inside has the connectingto class
      'has-[.connectingto]:border-border-brand-active',
      'has-[.connectingfrom]:border-border-brand-active',
      {
        'border-border-brand-active': selected,
      },
    ),
  );

  return (
    <div className={klass} {...props}>
      {children}
    </div>
  );
};
